import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactElement, useMemo } from "react";

const COLOR_START = [255, 255, 255];
const COLOR_END = [80, 121, 53];

interface CellProps extends FlexProps {
  n: number;
  minN: number;
  maxN: number;
}

export default function Cell(props: CellProps): ReactElement {
  const { n, minN, maxN, ...rest } = props;

  const color = useMemo(() => getColor((n - minN) / maxN), [maxN, minN, n]);

  return (
    <Flex justify="center" align="center" bg={color} {...rest}>
      {n}
    </Flex>
  );
}

function getColor(t: number): string {
  const mapped = COLOR_START.map((start, i) =>
    Math.round(start - (start - COLOR_END[i]) * t)
  );
  return `rgb(${mapped.join(",")})`;
}
